module.exports = __webpack_public_path__ + "img/ai-video-background.6ea08d45.jpg";